import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: white;
  padding: 12px 0;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const Access = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;

  @media (max-width: 768px) {
    flex-direction: column;
    margin-top: 15px;
  }
`;

export const Image = styled.img`
  width: 150px;
`;

export const ButttonHeader = styled.a`
  background-color: transparent;
  color: #006f5e;
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  border: 1px solid #006f5e;
  border-radius: 6px;
  padding: 8px 18px;
  cursor: pointer;
  text-decoration: none;

  &:hover {
    background-color: #006f5e;
    color: white;

    svg {
      fill: white;
    }
  }
`;

export const LogoLink = styled.a``;
